import { useState, useEffect } from "react";
import { Star } from "lucide-react";

function TestimonialSection() {
  const [currentPair, setCurrentPair] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const testimonials = [
    {
      id: 1,
      name: "Ayesha Ali",
      text: "Finding a good spouse is tough, especially for females",
      rating: 5,
      image:
        "Ayesha.png", // Placeholder image
    },
    {
      id: 2,
      name: "Umar Khan",
      text: "This is a legit platform to find your spouse",
      rating: 5,
      image:
        "Umar.png", // Placeholder image
    },
    {
      id: 3,
      name: "Kiran Rajpoot",
      text: "Best platform to find educated profiles",
      rating: 5,
      image:
        "Kiran.png", // Placeholder image
    },
    {
      id: 4,
      name: "Mubashir Butt",
      text: "I found my wife here. This platform turned out great for me",
      rating: 5,
      image:
        "Mubashir.png", // Placeholder image
    }
  ];

  const totalPairs = Math.ceil(testimonials.length / 2);

  // Auto rotate testimonials every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      nextTestimonialPair();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentPair]);

  const nextTestimonialPair = () => {
    if (isTransitioning) return;

    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentPair((prevPair) => (prevPair + 1) % totalPairs);
      setIsTransitioning(false);
    }, 1000); // Longer transition time for smoother effect
  };

  const renderStars = (rating) => {
    return Array(5)
      .fill(0)
      .map((_, i) => (
        <Star
          key={i}
          size={18}
          fill={i < rating ? "#FFD700" : "none"}
          stroke={i < rating ? "#FFD700" : "#D1D5DB"}
        />
      ));
  };

  const getCurrentPairIndices = () => {
    const startIndex = currentPair * 2;
    return [
      startIndex,
      startIndex + 1 < testimonials.length ? startIndex + 1 : null,
    ];
  };

  const [firstIndex, secondIndex] = getCurrentPairIndices();

  return (
    <div className=" py-16 px-4 font-sans overflow-hidden">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-center font-alex text-6xl font-semibold text-[#730000]  max-lg:text-5xl max-sm:text-4xl">
            Love is in the air
          </h2>
          <p className=" m-auto text-2xl max-lg:text-xl max-sm:text-[15px] font-seasons">
            Join thousands of happy couples who found their perfect match on
            SelectProposal
          </p>
        </div>

        <div className="relative">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* First testimonial card */}
            <div
              // style={{ boxShadow: "0 0 20px rgba(127, 29, 29, 0.8)" }}
              className={`bg-white  rounded-lg overflow-hidden transition-all border-[1px] border-red-800  duration-1000 ease-in-out transform ${
                isTransitioning
                  ? "translate-x-full opacity-0"
                  : "translate-x-0 opacity-100"
              }`}
            >
              <div className="flex flex-col items-center p-6">
                <div className="w-20 h-20 mb-4 rounded-full overflow-hidden">
                  <img
                    src={testimonials[firstIndex].image}
                    alt={testimonials[firstIndex].name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-xl font-bold text-[#730000]  mb-1">
                  {testimonials[firstIndex].name}
                </h3>
                <div className="flex justify-center mb-4">
                  {renderStars(testimonials[firstIndex].rating)}
                </div>
                <p className="text-center font-seasons">
                  {testimonials[firstIndex].text}
                </p>
              </div>
            </div>

            {/* Second testimonial card */}
            {secondIndex !== null && (
              <div
                // style={{}}
                className={` rounded-lg shadow-lg border-[1px] border-red-800 overflow-hidden transition-all duration-1000 ease-in-out transform ${
                  isTransitioning
                    ? "translate-x-full opacity-0"
                    : "translate-x-0 opacity-100"
                }`}
                style={{
                  transitionDelay: "150ms",
                  // boxShadow: "0 0 20px rgba(127, 29, 29, 0.8)",
                }}
              >
                <div className="flex flex-col items-center p-6">
                  <div className="w-20 h-20 mb-4 rounded-full overflow-hidden">
                    <img
                      src={testimonials[secondIndex].image}
                      alt={testimonials[secondIndex].name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-xl font-bold  mb-1">
                    {testimonials[secondIndex].name}
                  </h3>
                  <div className="flex justify-center mb-4">
                    {renderStars(testimonials[secondIndex].rating)}
                  </div>
                  <p className="text-center font-seasons">
                    {testimonials[secondIndex].text}
                  </p>
                </div>
              </div>
            )}
          </div>

          {/* Offscreen cards ready to slide in (shown when transitioning) */}
          <div className="absolute top-0 left-0 w-full grid grid-cols-1 md:grid-cols-2 gap-6 pointer-events-none">
            {isTransitioning && (
              <>
                {/* Next first card */}
                <div className=" rounded-lg shadow-lg overflow-hidden transition-all duration-1000 ease-in-out transform -translate-x-full opacity-0">
                  <div className="flex flex-col items-center p-6">
                    <div className="w-20 h-20 mb-4 rounded-full overflow-hidden">
                      <img
                        src={
                          testimonials[(firstIndex + 2) % testimonials.length]
                            .image
                        }
                        alt={
                          testimonials[(firstIndex + 2) % testimonials.length]
                            .name
                        }
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                </div>

                {/* Next second card */}
                {(firstIndex + 3) % testimonials.length <
                  testimonials.length && (
                  <div className=" rounded-lg shadow-lg overflow-hidden transition-all duration-1000 ease-in-out transform -translate-x-full opacity-0">
                    <div className="flex flex-col items-center p-6">
                      <div className="w-20 h-20 mb-4 rounded-full overflow-hidden">
                        <img
                          src={
                            testimonials[(firstIndex + 3) % testimonials.length]
                              .image
                          }
                          alt={
                            testimonials[(firstIndex + 3) % testimonials.length]
                              .name
                          }
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        {/* Indicator dots */}
        <div className="flex justify-center mt-8 space-x-2">
          {Array(totalPairs)
            .fill(0)
            .map((_, index) => (
              <div
                key={index}
                className={`w-2 h-2 rounded-full transition-colors ${
                  currentPair === index ? "bg-red-300" : "bg-[#730000]"
                }`}
                aria-hidden="true"
              />
            ))}
        </div>
      </div>
    </div>
  );
}

export default TestimonialSection;
